import { JsxComponentDescriptor } from '@mdxeditor/editor'
import { chain, isString } from 'lodash'
import { MdxJsxAttribute, MdxJsxExpressionAttribute } from 'mdast-util-mdx-jsx'
import { ModelType, ReplyCitationDTO } from '../../../swagger/dto'
import Footnote from './components/Footnote'
import GoodsItem from './components/GoodsItem'
import InlineImage from './components/InlineImage'
import Suggestion from './components/Suggestion'
import TextSplitter from './components/TextSplitter'

export const ANSWER_DURATION_BY_TYPE = {
    [ModelType.TEXT]: 5,
    [ModelType.IMAGE]: 15,
    [ModelType.VIDEO]: 60,
    [ModelType.AUDIO]: 20,
    [ModelType.SPEECH]: 15,
}

const mapAttributesToProps = (attributes: Array<MdxJsxAttribute | MdxJsxExpressionAttribute>) =>
    chain(attributes)
        .keyBy('name')
        .mapValues((attr) => (isString(attr.value) ? attr.value : ''))
        .value()

export const getFootnoteDescriptor = (citations: ReplyCitationDTO[]): JsxComponentDescriptor => ({
    name: 'Footnote',
    kind: 'flow',
    props: [
        {
            name: 'index',
            type: 'number',
        },
    ],
    hasChildren: false,
    Editor: ({ mdastNode }) => {
        const [indexAttribute] = mdastNode.attributes
        const index = isString(indexAttribute.value) ? parseInt(indexAttribute.value) : 0

        return <Footnote index={index} citations={citations} />
    },
})

export const getSuggestionDescriptor = (
    onClick: (text: string) => void,
): JsxComponentDescriptor => ({
    name: 'Suggestion',
    kind: 'flow',
    props: [
        {
            name: 'text',
            type: 'string',
        },
    ],
    hasChildren: false,
    Editor: ({ mdastNode }) => {
        const [textAttribute] = mdastNode.attributes
        const text = isString(textAttribute.value) ? textAttribute.value : ''

        return <Suggestion onClick={onClick} text={text} />
    },
})

export const getGoodsItemDescriptor = (): JsxComponentDescriptor => ({
    name: 'GoodsItem',
    kind: 'flow',
    props: [
        {
            name: 'title',
            type: 'string',
        },
        {
            name: 'image',
            type: 'string',
        },
        {
            name: 'price',
            type: 'string',
        },
        {
            name: 'link',
            type: 'string',
        },
        {
            name: 'source',
            type: 'string',
        },
    ],
    hasChildren: false,
    Editor: ({ mdastNode }) => {
        const props = mapAttributesToProps(mdastNode.attributes)

        return <GoodsItem {...props} />
    },
})

export const getTextSplitterDescriptor = (): JsxComponentDescriptor => ({
    name: 'TextSplitter',
    kind: 'flow',
    props: [
        {
            name: 'text',
            type: 'string',
        },
    ],
    hasChildren: false,
    Editor: ({ mdastNode }) => {
        const [textAttribute] = mdastNode.attributes
        const text = isString(textAttribute.value) ? textAttribute.value : ''

        return <TextSplitter text={text} />
    },
})

export const getInlineImageDescriptor = (): JsxComponentDescriptor => ({
    name: 'InlineImage',
    kind: 'flow',
    props: [
        {
            name: 'href',
            type: 'string',
        },
    ],
    hasChildren: false,
    Editor: ({ mdastNode }) => {
        const [textAttribute] = mdastNode.attributes
        const text = isString(textAttribute.value) ? textAttribute.value : ''

        return <InlineImage href={text} />
    },
})
